import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function GraphYearly({ data,dataMetrics }) {
    const [months, setMonths] = useState([]);
    const [rent, setRent] = useState([]);
    const [expenses, setExpenses] = useState([]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const monthsArray = data.map(item => item.month);
            const rentArray = data.map(item => item.total_rent_income || 0);
            const expensesArray = data.map(item =>
                (item.utilites_total || 0) + (item.total_expense_maintenance_income || 0)
            );
            setMonths(monthsArray);
            setRent(rentArray);
            setExpenses(expensesArray);
        }
    }, [data]);

    const options = {
        chart: {
            id: "rental-income",
            toolbar: {
                show: false,
            },
            fontFamily: 'Inter, sans-serif',
        },
        xaxis: {
            categories: months,
            labels: {
                style: {
                    colors: "#374151", 
                    fontSize: '14px',
                },
            },
        },
        yaxis: {
            title: {
                text: "Amount (Ksh)",
                style: {
                    color: "#374151",
                    fontWeight: 600,
                    fontSize: '13px',
                },
            },
            labels: {
                style: {
                    colors: "#6B7280", 
                    fontSize: '13px',
                },
            },
        },
        colors: ["#2563eb", "#facc15"], 
        plotOptions: {
            bar: {
                borderRadius: 6,
                columnWidth: '45%',
            },
        },
        legend: {
            show: false, 
        },
        dataLabels: {
            enabled: false,
        },
        grid: {
            borderColor: "#E5E7EB", 
            strokeDashArray: 4,
        },
        tooltip: {
            theme: 'light',
        },
    };
    const series = [
        {
          name: 'Income',
          data: rent,
          color: '#000000',
        },
        {
          name: 'Expenses',
          data: expenses,
          color: '#ffd700',
        },
    ];
    return (
        <div className="mx-auto mt-8 p-8 rounded-2xl max-w-8xl rent-income-chart">
            <h2 className="mb-6 font-bold text-gray-800 text-3xl text-center tracking-tight">
                Rental Income vs Expenses
            </h2>
            {/* Custom Legend */}
            <div className="flex justify-center gap-8 mb-4">
                <div className="flex items-center gap-2">
                    <span className="inline-block bg-black rounded w-4 h-4"></span>
                    <span className="font-medium text-gray-700">Rent</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="inline-block bg-yellow-500 rounded w-4 h-4"></span>
                    <span className="font-medium text-gray-700">Expenses</span>
                </div>
            </div>
            {Array.isArray(data) && months.length > 0 ? (
                <ReactApexChart
                    options={options}
                    series={series}
                    type="bar"
                    height={400}
                />
            ) : (
                <div className="py-12 text-gray-500 text-center">Loading chart data...</div>
            )}
        </div>
    );
}





// import React, { useEffect, useState } from 'react';
// import ReactApexChart from 'react-apexcharts';

// export default function GraphYearly({ data, dataMetrics }) {
//     const [months, setMonths] = useState([]);
//     const [rent, setRent] = useState([]);
//     const [expenses, setExpenses] = useState([]);

//     useEffect(() => {
//         if (data && Array.isArray(data)) {
//             const currentMonth = new Date().getMonth(); // Get current month (0-11)
//             const currentMonthName = new Date().toLocaleString('default', { month: 'long' });
            
//             const monthsArray = data.map(item => item.month);
//             const rentArray = data.map(item => {
//                 // If this is the current month, use dataMetrics.rent_paid
//                 if (item.month.toLowerCase() === currentMonthName.toLowerCase()) {
//                     return dataMetrics?.rent_paid || item.total_rent_income || 0;
//                 }
//                 return item.total_rent_income || 0;
//             });
            
//             const expensesArray = data.map(item =>
//                 (item.utilites_total || 0) + (item.total_expense_maintenance_income || 0)
//             );
            
//             setMonths(monthsArray);
//             setRent(rentArray);
//             setExpenses(expensesArray);
//         }
//     }, [data, dataMetrics]); // Add dataMetrics to dependency array

//     const options = {
//         chart: {
//             id: "rental-income",
//             toolbar: {
//                 show: false,
//             },
//             fontFamily: 'Inter, sans-serif',
//         },
//         xaxis: {
//             categories: months,
//             labels: {
//                 style: {
//                     colors: "#374151", 
//                     fontSize: '14px',
//                 },
//             },
//         },
//         yaxis: {
//             title: {
//                 text: "Amount (Ksh)",
//                 style: {
//                     color: "#374151",
//                     fontWeight: 600,
//                     fontSize: '13px',
//                 },
//             },
//             labels: {
//                 style: {
//                     colors: "#6B7280", 
//                     fontSize: '13px',
//                 },
//             },
//         },
//         colors: ["#2563eb", "#facc15"], 
//         plotOptions: {
//             bar: {
//                 borderRadius: 6,
//                 columnWidth: '45%',
//             },
//         },
//         legend: {
//             show: false, 
//         },
//         dataLabels: {
//             enabled: false,
//         },
//         grid: {
//             borderColor: "#E5E7EB", 
//             strokeDashArray: 4,
//         },
//         tooltip: {
//             theme: 'light',
//         },
//     };

//     const series = [
//         {
//             name: 'Income',
//             data: rent,
//             color: '#000000',
//         },
//         {
//             name: 'Expenses',
//             data: expenses,
//             color: '#ffd700',
//         },
//     ];

//     return (
//         <div className="mx-auto mt-8 p-8 rounded-2xl max-w-8xl rent-income-chart">
//             <h2 className="mb-6 font-bold text-gray-800 text-3xl text-center tracking-tight">
//                 Rental Income vs Expenses
//             </h2>
//             {/* Custom Legend */}
//             <div className="flex justify-center gap-8 mb-4">
//                 <div className="flex items-center gap-2">
//                     <span className="inline-block bg-black rounded w-4 h-4"></span>
//                     <span className="font-medium text-gray-700">Rent</span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <span className="inline-block bg-yellow-500 rounded w-4 h-4"></span>
//                     <span className="font-medium text-gray-700">Expenses</span>
//                 </div>
//             </div>
//             {Array.isArray(data) && months.length > 0 ? (
//                 <ReactApexChart
//                     options={options}
//                     series={series}
//                     type="bar"
//                     height={400}
//                 />
//             ) : (
//                 <div className="py-12 text-gray-500 text-center">Loading chart data...</div>
//             )}
//         </div>
//     );
// }